export const shuffle = (arr: Array<unknown>) => arr.sort(() => (Math.random() > 0.5 ? 1 : -1));
